module.exports = "/fonts/Gineso-Norm-Demi.otf";